import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { log, logError } from '../utils/log';

// Types for our data
export interface BookingData {
  ownerName: string;
  petName: string;
  serviceType: string;
  email: string;
  phone: string;
  timestamp?: any;
  status?: 'new' | 'contacted' | 'scheduled' | 'completed';
}

export interface ContactData {
  name: string;
  email: string;
  phone: string;
  message: string;
  smsConsent?: boolean;
  timestamp?: any;
  status?: 'new' | 'responded' | 'resolved';
}

// Save booking to Firestore
export const saveBooking = async (bookingData: BookingData): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'bookings'), {
      ...bookingData,
      timestamp: serverTimestamp(),
      status: 'new'
    });

    log('Booking saved with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    logError('Error saving booking:', error);
    throw error;
  }
};

// Save contact form to Firestore
export const saveContact = async (contactData: ContactData): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'contacts'), {
      ...contactData,
      timestamp: serverTimestamp(),
      status: 'new'
    });

    log('Contact saved with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    logError('Error saving contact:', error);
    throw error;
  }
};

// Save prospect (general lead) to Firestore
export const saveProspect = async (prospectData: Partial<BookingData & ContactData>): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'prospects'), {
      ...prospectData,
      timestamp: serverTimestamp(),
      source: 'website',
      status: 'new'
    });

    log('Prospect saved with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    logError('Error saving prospect:', error);
    throw error;
  }
};
